import React from 'react';
import BooleanStep from './BooleanStep';

export default class WelectGate extends React.Component {
  render() {
    return (
      <BooleanStep
        {...this.props}
        labelText={ 'Welect' }
      />
    );
  }
}
